<template>
    <div class="column is-9">
        <section class="hero is-info welcome is-small">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Perfil de Usuario
                    </h1>
                    <h2 class="subtitle">
                        
                    </h2>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <form @submit.prevent="submit">
                            <h2 class="title is-4">Datos de Usuario</h2>
                            
                            <ul class="content is-medium">
                                <li>
                                    <span><strong>Nombre: </strong></span>
                                    <span>{{user.name}}</span>
                                </li>
                                <li>
                                    <span><strong>DNI: </strong></span>
                                    <span>{{user.dni}}</span>
                                </li>
                                <!-- <li>
                                    <span><strong>Email: </strong></span>
                                    <span>{{user.email}}</span>
                                </li> -->
                                <li>
                                    <span><strong>Matrícula: </strong></span>
                                    <span>{{user.matricula}}</span>
                                </li>
                            </ul>
                            <br />                        

                            <h2 class="title is-4">Modificar Datos de Contacto</h2>

                            <div class="field">
                                <div class="control">
                                    <input class="input is-medium" type="text" placeholder="Email"
                                        name="email" id="email" v-model="user.email">
                                </div>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <input class="input is-medium" type="text" placeholder="Celular"
                                        name="celular" id="celular" v-model="user.celular">
                                        <small class="has-text-grey-light">Ingrese la característica sin el 0 y omita el 15 inicial. Ej.: 3416123456</small>
                                </div>
                            </div>

                            <br />                        

                            <h2 class="title is-4">Modificar Contraseña</h2>

                            <div class="field">
                                <div class="control">
                                    <input class="input is-medium" type="password" placeholder="Contraseña"
                                        name="password" id="password" v-model="form.password">
                                </div>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <input class="input is-medium" type="password" placeholder="Repetir Contraseña"
                                        name="password_confirmation" id="password_confirmation" v-model="form.password_confirmation">
                                </div>
                            </div>

                            <button 
                                :disabled="this.form.password != this.form.password_confirmation" 
                                class="button is-block is-primary is-fullwidth is-medium">Actualizar</button>

                            <small class="has-text-danger"><em>{{errors}}</em></small>
                            <small class="has-text-success"><em>{{messages}}</em></small>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'profile',
    data(){
        return{
            form:{
                password: '',
                password_confirmation: '',
                email: '',
                celular: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
            messages: 'auth/messages'
        }),
    },
    methods:{
        ...mapActions({
            updateUser: 'auth/updateUser',
        }),
        submit(){
            
            this.form.email = this.user.email;
            this.form.celular = this.user.celular;

            this.updateUser(this.form)
                .then(() => {
                    this.form.password = '';
                    this.form.password_confirmation = '';
                }).catch(() => {
                    console.log("Login Failed!");
                })
        },
    }
}
</script>
